import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export const useUserRole = () => {
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isAgencyMember, setIsAgencyMember] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkRole = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) {
          setIsSuperAdmin(false);
          setIsAgencyMember(false);
          setIsLoading(false);
          return;
        }

        // Check for any role in user_roles table
        const { data, error } = await supabase
          .from('user_roles')
          .select('role')
          .eq('user_id', user.id)
          .maybeSingle();

        if (error && error.code !== 'PGRST116') {
          console.error('Error checking role:', error);
        }

        const hasRole = !!data;
        setIsAgencyMember(hasRole);
        setIsSuperAdmin(data?.role === 'super_admin');
      } catch (error) {
        console.error('Error checking role:', error);
        setIsSuperAdmin(false);
        setIsAgencyMember(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkRole();
  }, []);

  return { isSuperAdmin, isAgencyMember, isLoading };
};
